/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Project.Entrypoint
 * OpenAPI spec version: 1.0.0
 */

export type UserRole = typeof userRole[keyof typeof userRole];

export const userRole = {
  Admin: 'admin',
  LeadProvider: 'leadProvider',
  Mandatary: 'mandatary',
  Viewer: 'viewer',
} as const;
